module.exports = __webpack_public_path__ + "img/notes.8ffb154a.svg";